// extracted by mini-css-extract-plugin
export default {"ticket-wrapper":"Ticket_ticket-wrapper__n6ntF","details":"Ticket_details__nL-rS","line":"Ticket_line__5lX-+","nothing":"Ticket_nothing__K-TyD"};